export function isEncrypted(value) {
    return value !== null && typeof value === 'object' && !!value.klass && value.klass === 'Encrypted';
}